<template>
  <section>
    <v-container class="fill-height" fluid>
      <v-row class="mx-auto" align="center" justify="center" v-if="!is_authen">
        <v-col class="col-12 px-0">
          <v-card
            class="card-box mx-auto pb-3"
            :loading="loading"
            :disabled="disabled"
          >
            <v-toolbar color="#F36A00" dark flat>
              <v-toolbar-title>KMITL Registration System</v-toolbar-title>
            </v-toolbar>
            <v-form ref="form" v-model="valid" @submit.prevent="">
              <v-card v-if="!is_dev_env" class="ma-5" color="grey lighten-4">
                <v-card-title
                  class="d-flex justify-center font-weight-bold pa-3"
                  >{{ $t("login.google_authen_title") }}</v-card-title
                >
                <v-card-text class="d-flex justify-center pa-0">{{
                  $t("login.google_authen_text")
                }}</v-card-text>
                <v-card-actions class="d-flex justify-center pa-3">
                  <v-btn
                    color="white"
                    href="https://accounts.google.com/o/oauth2/auth?
									response_type=code&
									access_type=online&
									client_id=277499851660-krmerm1cop2o8c144dqg57d2f661r21p.apps.googleusercontent.com&
									redirect_uri=https%3A%2F%2Fnew.reg.kmitl.ac.th%2Fapi%2Fuser%2FgoogleOAuthToken.php&
									state&
									scope=email%20profile&
									prompt=select_account"
                  >
                    <v-img
                      src="googleLogo.png"
                      class="mr-1"
                      max-width="22"
                    ></v-img>
                    Login
                  </v-btn>
                </v-card-actions>
              </v-card>

              <div v-if="!is_dev_env" class="separator">หรือ</div>

              <v-card class="ma-5" color="grey lighten-4">
                <v-card-title
                  class="d-flex justify-center font-weight-bold pa-3"
                  >{{ $t("login.university_authen_title") }}
                </v-card-title>
                <v-card-text class="d-flex justify-center pa-0">{{
                  $t("login.university_authen_text")
                }}</v-card-text>
                <v-card-text>
                  <v-text-field
                    label="Username (e.g. 66019999, 66019999@kmitl.ac.th)"
                    v-model="email"
                    type="text"
                    :rules="emailRules"
                    required
                  ></v-text-field>
                  <v-text-field
                    label="Password"
                    v-model="password"
                    type="password"
                    :rules="passwordRules"
                    required
                  ></v-text-field>
                </v-card-text>
                <v-card-actions class="d-flex justify-center pb-3">
                  <v-btn
                    type="submit"
                    color="primary"
                    :disabled="!valid"
                    @click="loginJWT"
                    >Login</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-form>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
import UserCentralProvider from "@/services/user.central.provider.js";
const userCentralService = new UserCentralProvider();

export default {
  name: "Login",
  components: {},
  data: () => ({
    loading: false,
    disabled: false,

    valid: false,
    email: "",
    emailRules: [
      (v) => !!v || "E-mail is required",
      // (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
    ],
    password: "",
    passwordRules: [
      (v) => !!v || "Password is required",
      (v) => v.length >= 10 || "Password must be larger than 10 characters",
    ],
    error_message: "",

    is_authen: false,

    is_dev_env: false,
    env: process.env.VUE_APP_ENV,
  }),
  computed: {},

  methods: {
    // async update() {
    //   if (this.$store.state.user.is_authen) {
    //     this.is_authen = this.$store.state.user.is_authen;
    //     this.is_authorized_officer =
    //       this.$store.state.user.is_authorized_officer;
    //     this.user_info = this.$store.state.user.user_info;
    //   }
    // },

    async loginJWT() {
      if (!this.valid) return;
      this.loading = true;
      this.disabled = true;
      const response = await userCentralService
        .loginJWT(this.email, this.password)
        .catch((error) => {
          this.$toasted.error(JSON.stringify(error.response.data.message), {
            duration: 0,
          });
        });
      if (response) {
        await sessionStorage.setItem("token", response.token);
        this.$router.push("/").catch(() => {});
      }
      this.loading = false;
      this.disabled = false;
    },

    isLogin() {
      if (this.$store.state.user.is_authen) {
        this.$router.push("/").catch(() => {});
      }
    },

    isDevEnv() {
      if (process.env.VUE_APP_ENV !== "production") this.is_dev_env = true;
    },
  },
  mounted() {
    this.isLogin();
    this.isDevEnv();
  },
};
</script>
<style scoped>
.separator {
  display: flex;
  align-items: center;
  text-align: center;
  padding-top: 10px;
  padding-bottom: 10px;
  color: rgb(180, 180, 180);
}
.separator::before,
.separator::after {
  content: "";
  flex: 1;
  border-bottom: 1px solid rgb(235, 235, 235);
}

.separator::before {
  margin-right: 0.25em;
}

.separator::after {
  margin-left: 0.25em;
}

.card-box {
  max-width: 500px;
}
</style>
